import { render, staticRenderFns } from "./ConfirmReportModal.vue?vue&type=template&id=334baf7e&"
import script from "./ConfirmReportModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports